import React from 'react';
import styles from './confirm-modal.module.css';

interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    description?: string;
    confirmText?: string;
    cancelText?: string;
    loadingText?: string;
    isLoading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    isOpen,
    title,
    description,
    confirmText = 'Удалить',
    cancelText = 'Отмена',
    loadingText,
    isLoading = false,
    onConfirm,
    onCancel,
}) => {
    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onCancel}>
            <div
                className={styles.modal}
                onClick={e => e.stopPropagation()}
            >
                <h3 className={styles.title}>{title}</h3>

                {description && (
                    <p className={styles.description}>{description}</p>
                )}

                <div className={styles.actions}>
                    <button
                        type="button"
                        className={styles.cancel}
                        onClick={onCancel}
                        disabled={isLoading}
                    >
                        {cancelText}
                    </button>

                    <button
                        type="button"
                        className={styles.confirm}
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? (loadingText ?? 'Удаление…') : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
